import { useEffect } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { api } from "../../components/api/api";
import { Alert, Pergunta, AlertErro } from "../../util/Alertas";

export default function QRCodeScanner() {

    useEffect(() => {
        async function startCamera() {
            await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "environment" }
            });
        }

        startCamera();
    }, []);

    useEffect(() => {
        api.get("/")
    }, [])

    const handleEditarStatus = (pedido_id) => {
        const data = new FormData();
        const obj = JSON.stringify({
            PedidoId: pedido_id,
            StatusPedidoId: 6,
            Motivo: ""
        });
        data.append("obj", obj);
        api.post('/api/pedidos/AtualizarStatusPedido', data
            , () =>
                Alert(`Status do pedido #${pedido_id} atualizado com sucesso!`)
            , error =>
                AlertErro(error, 'Erro ao alterar o status do pedido.')
        );

    };

    const onBuscarPedido = (codigo_barras) => {
        api.get(`/api/pedidos/BuscarTodos?codigo_barras=${codigo_barras}`, async res => {
            if (res.data.pedidos.length > 0) {
                const pedido = res.data.pedidos[0];
                const confirm = await Pergunta(`Deseja confirmar a entrega do pedido #${pedido.pedido_id}?`)
                if (confirm) {
                    handleEditarStatus(pedido.pedido_id)
                }
                return;
            }

            Alert(`Pedido Não encontrado Cd:${codigo_barras}`, false)
        })
    }

    return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
            <h1>Leitor de QR Code</h1>

            <div style={{ display: "flex", justifyContent: "center" }}>
                <BarcodeScannerComponent
                    width={400}
                    height={400}
                    delay={300}
                    onUpdate={(err, result) => {
                        if (result) {
                            onBuscarPedido(result.text)
                        }
                    }}
                />
            </div>
        </div>
    );
}